import { memo, Fragment, useEffect, useState } from "react";

import WithoutCashbackIcon from "../../Assets/SvgIcons/WithoutCashback";
import WithCashbackIcon from "../../Assets/SvgIcons/WithCashback";
import { priceDigitSeperator } from "../../Utils/Helpers";
import { getPaymentOptions } from "../../Actions/Actions";
import DontCashback from "./DontCashback";
import Item from "./Item";
import "./styles.css";
import { getSoftposPaymentOptions } from "../../Actions/DaapAppSoftPosActions/SoftPosActions";

const WalletSwitch = (props) => {
  const [dontCashbackModal, setDontCashbackModal] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [options, setOptions] = useState([]);
  const { businessId, subCategoryId, isSoftpos, transactionId, cardNo } = props;

  useEffect(() => {
    if (isSoftpos) {
      getSoftposPaymentOptions(cardNo, transactionId).then((res) => {
        setOptions(res.paymentOptions);
        setSelectedOptions(res.selectedPaymentOptions);
        props.selectedPaymentOptions(res.selectedPaymentOptions);
        let credit = 0;
        res.paymentOptions.forEach(
          (item) => (credit += parseFloat(item.credit)),
        );
        props.credit(credit);
      });
    } else {
      getPaymentOptions(businessId, subCategoryId).then((res) => {
        setOptions(res.paymentOptions);
        setSelectedOptions(res.selectedPaymentOptions);
        props.selectedPaymentOptions(res.selectedPaymentOptions);
        let credit = 0;
        res.paymentOptions.forEach(
          (item) => (credit += parseFloat(item.credit)),
        );
        props.credit(credit);
      });
    }
  }, []);

  const onClickSwitch = (value, item) => {
    let newArray = selectedOptions;
    if (value) {
      if (!item.has_payment_reward) {
        setDontCashbackModal(true);
      }
      newArray.push(item);
    } else {
      newArray = newArray.filter((it) => it.id !== item.id);
    }
    setSelectedOptions(newArray);
    props.selectedPaymentOptions([...new Set(newArray)]);
  };

  return (
    <Fragment>
      {options.map((item, index) => {
        return (
          <Item
            isSoftpos
            key={index}
            item={item}
            onClick={(value) => onClickSwitch(value, item)}
          />
        );
      })}
      <Footer />
      <DontCashback
        visible={dontCashbackModal}
        onClose={() => setDontCashbackModal(false)}
      />
    </Fragment>
  );
};
export default memo(WalletSwitch);

const Footer = () => {
  return (
    <div className="mt-3">
      <div className="d-flex justify-content-start w-100">
        <span>راهنما</span>
      </div>
      <div className="d-flex flex-column align-items-start justify-content-start mt-3">
        <div>
          <WithCashbackIcon color={"#009B7F"} size={17} />
          <small
            className="WalletSwitch-switch-description-title"
            style={{ color: "#009B7F" }}
          >
            با بازگشت وجه خرید
          </small>
        </div>
        <div>
          <WithoutCashbackIcon color={"#C2CDD9"} size={17} />
          <small className="WalletSwitch-switch-description-title text-muted">
            بدون بازگشت وجه خرید
          </small>
        </div>
      </div>
    </div>
  );
};
